import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BusinessTypeSelectModalComponent} from './business-type-select-modal';
import {BusinessType} from './add-business-form-data';

/**
 * The one way to start adding a business: pick the form flavour (individual / company /
 * cooperative) in the modal, then open the add form with that choice. Used by the business list
 * and by any page that sends the user off to create their first business.
 */
@Injectable({providedIn: 'root'})
export class AddBusinessFlowService {
  private readonly modalService = inject(NgbModal);
  private readonly router = inject(Router);

  start(): void {
    const modalRef = this.modalService.open(BusinessTypeSelectModalComponent, {size: 'md', centered: true});
    modalRef.result
      .then((businessType: BusinessType) => {
        void this.router.navigate(['/profile/business/add'], {state: {businessType}});
      })
      .catch(() => undefined);
  }
}
